import React, { useContext } from 'react';
import { ExplorerContext } from '../../../application/config';
import {
	StoryFactory,
	StoryQuery,
} from '../../../models/factories/StoryFactory';
import StoryBookmarks from '../../Catalogue/Bookmarks/BookmarkLists/StoryBookmarks';
import NoResults from './NoResults';
import { useAppSelector } from '../../../state/hooks';
import { selectPrefs } from '../../../state/selectors';
import { shallowEqual } from 'react-redux';
import {
	filterStoriesByAccessibility,
	sortStoriesByPreferences,
} from '../../../models/helpers/preferenceRanking';

type ResultProps = {
	term: string;
};

const StoryResults: React.FC<ResultProps> = ({ term }) => {
	const AppData = useContext(ExplorerContext);
	const userPrefs = useAppSelector(selectPrefs, shallowEqual);
	const query: StoryQuery = {
		filter: {
			title: term,
		},
	};
	const all_stories = StoryFactory.filter(
		AppData.features?.all_stories ?? StoryFactory.getEmpty(),
		query,
	);
	const results = StoryFactory.filter(all_stories, query);
	const prioritisedStories = sortStoriesByPreferences(
		filterStoriesByAccessibility([...results.stories], userPrefs),
		userPrefs,
	);
	return (
		<>
			{prioritisedStories.length > 0 && (
				<StoryBookmarks stories={prioritisedStories} />
			)}
			{prioritisedStories.length === 0 && <NoResults />}
		</>
	);
};

export default StoryResults;
